import { useEffect } from 'react';
//** Context */
import { Navigate } from 'react-router';
import useBackListener from 'src/hooks/useBackListener.ts';
import usePreQualificationPages from 'src/hooks/usePreQualificationPages';
//* ----------------------------------------------------------------

export default function PageGuard({ children }) {
  const { funcs } = usePreQualificationPages();
  // !! Check to ensure that we can go to a specific page
  // !! If the page is valid or the  page is next in the page sequence, allow access
  // !! else return to the last valid page.

  // ? Get this from the Pages Context - Pass in the index of the page we are trying to access
  const pageIndex = { ...children }.props.pageIndex;

  // Check if this is a page reload (F5)
  useEffect(() => {
    window.onbeforeunload = () => {
      return '';
    };
  }, []);
  const navType = useBackListener();

  // Ensure we are allowed to navigate to the requested page
  const responsePage = funcs.getRequestPage({
    requestPageIndex: pageIndex,
    navType: navType,
  });

  // Check if this is a navigation 'back'
  if (responsePage.allowPageRequest === false || responsePage.isBack === true) {
    return <Navigate to={responsePage.responsePage.previousRoutePath} />;
  }

  // No issue, load the page.
  return <>{children}</>;
}
